import { createFileRoute } from '@tanstack/react-router';
import { ProjectSettingsPage } from '../features/projects/project-settings-page';
export const Route = createFileRoute('/manage/$companySlug/projects/$projectId/settings')({
  component: RouteComponent,
});
function RouteComponent() {
  const { companySlug, projectId } = Route.useParams();
  return <ProjectSettingsPage companySlug={companySlug} projectId={projectId} />;
}
